import { useState, useEffect } from 'react';
import { useTheme } from 'styled-components';
import { defaultToolkitTheme } from '../components/theme/defaultToolkitTheme.js';
import '../components/theme/vmTheme.js';
import '../components/theme/wmTheme.js';
import '../components/theme/GlobalStyle.js';
import '../components/theme/ThemeProvider.js';

var useBreakpointIndex = function (options) {
  if (options === void 0) {
    options = {};
  }
  var theme = useTheme() || defaultToolkitTheme;
  var _a = options.defaultIndex,
    defaultIndex = _a === void 0 ? 0 : _a;
  var breakpoints = theme && theme.breakpoints || defaultToolkitTheme.breakpoints;
  if (typeof defaultIndex !== "number") {
    throw new TypeError("Default breakpoint index should be a number. Got: ".concat(defaultIndex, ", ").concat(typeof defaultIndex));
  } else if (defaultIndex < 0 || defaultIndex > breakpoints.length - 1) {
    throw new RangeError("Default breakpoint index out of range. Theme has ".concat(breakpoints.length, " breakpoints, got index ").concat(defaultIndex));
  }
  var _b = useState(defaultIndex),
    value = _b[0],
    setValue = _b[1];
  useEffect(function () {
    var getIndex = function () {
      return breakpoints.filter(function (breakpoint) {
        return window.matchMedia("screen and (min-width: ".concat(breakpoint, ")")).matches;
      }).length - 1;
    };
    var onResize = function () {
      var newValue = getIndex();
      if (value !== newValue) {
        setValue(newValue);
      }
    };
    onResize();
    window.addEventListener("resize", onResize);
    return function () {
      return window.removeEventListener("resize", onResize);
    };
  }, [breakpoints, value]);
  return value;
};
var useResponsiveValue = function (values, options) {
  if (options === void 0) {
    options = {};
  }
  var theme = useTheme() || defaultToolkitTheme;
  var array = typeof values === "function" ? values(theme) : values;
  var final = Array.isArray(array) ? array : [array];
  var index = useBreakpointIndex(options);
  return final[index >= final.length ? final.length - 1 : index];
};

export { useBreakpointIndex, useResponsiveValue };
//# sourceMappingURL=use-match-media.js.map
